import apiActions from "app/utils/apiActions";

let authActions = {
  async submitEmail(email) {
    return await apiActions.request(`users/submit_email`, "POST", { email });
  },
  async submitVerificationCode(email, verification_code) {
    return await apiActions.request(`users/submit_verification_code`, "POST", {
      email,
      verification_code,
    });
  },
  async updateNotifToken(notifToken = null) {
    if (notifToken) {
      console.warn("updating resssion");
      let res = await apiActions.request(
        `users/update_notification_token`,
        "POST",
        {
          notification_token: notifToken,
        }
      );
      console.warn(res);
      return res;
    }
  },
};

export default authActions;
